/****************************************************
 * Module Name:  savedsearchhistoryProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "./../../api/restAPICall";
import Constants from "./../../constants";

export default class SavedsearchhistoryProxy {
    static getQueryForData = (callback) => {
        restAPICall(
          Constants.MANAGER_URL + "/savesearchhistory/queryfor/mini",
          "get",
          Constants.userToken,
          undefined,
          undefined,
          undefined,
          0
        )
          .then((response) => callback(response))
          .catch((error) => {
            callback(undefined);
          });
      };
    
      static getQueryFromData = (callback) => {
        restAPICall(
          Constants.MANAGER_URL + "/savesearchhistory/queryfrom/mini",
          "get",
          Constants.userToken,
          undefined,
          undefined,
          undefined,
          0
        )
          .then((response) => callback(response))
          .catch((error) => {
            callback(undefined);
          });
      };
    
      static getSearchHistory = (data, callback) => {
        restAPICall(
          Constants.MANAGER_URL + "/savesearchhistory",
          "post",
          Constants.userToken,
          undefined,
          JSON.stringify(data),
          "application/json",
          0
        )
          .then((response) => callback(response))
          .catch((error) => {
            callback(undefined);
          });
      };    

      static getLatestSaveSearchHistory = (userId, callback) => {
        restAPICall(
          Constants.MANAGER_URL + "/savesearchhistory/latestsearch/" + userId,
          "get",
          Constants.userToken,
          undefined,
          undefined,
          undefined,
          0
        )
          .then((response) => callback(response))
          .catch((error) => {
            callback(undefined);
          });
      };    
}
